import { useMutation } from "@apollo/client";
import { GoalState } from "types/graphql-schema";

import getArtifactActivitiesQuery from "@apps/artifact-sidebar/graphql/get-artifact-activities-query";
import getDashboardGoalsQuery from "@apps/dashboard-new/graphql/get-dashboard-goals-query";
import getMeetingGoalsQuery from "@apps/meeting-new/graphql/get-meeting-goals-query";
import { buttonTheme } from "@components/button/button-constants";
import DeprecatedSelect, { SelectOption } from "@components/select/select";
import { goalStateLabel } from "@helpers/constants";

import updateArtifactMutation from "../graphql/update-artifact-mutation";

const GoalStateComponent = ({
  artifact,
}: {
  artifact: {
    id: number;
    state: GoalState;
    canUpdate: { permission: boolean };
  };
}) => {
  const [updateArtifact] = useMutation(updateArtifactMutation);

  const handleChangeState = ({ value: newState }: SelectOption<GoalState>) => {
    updateArtifact({
      variables: {
        artifactId: artifact.id,
        additionalFields: { state: newState },
      },
      optimisticResponse: {
        createOrUpdateArtifact: {
          artifact: {
            ...artifact,
            state: newState,
          },
          __typename: "CreateOrUpdateArtifactMutation",
        },
      },
      refetchQueries: [
        getDashboardGoalsQuery,
        getMeetingGoalsQuery,
        getArtifactActivitiesQuery,
      ],
    });
  };

  return (
    <DeprecatedSelect<GoalState>
      disabled={!artifact.canUpdate.permission}
      options={[
        {
          value: GoalState.Draft,
          label: goalStateLabel[GoalState.Draft],
        },
        {
          value: GoalState.Open,
          label: goalStateLabel[GoalState.Open],
        },
        {
          value: GoalState.Closed,
          label: goalStateLabel[GoalState.Closed],
        },
      ]}
      value={artifact.state}
      onChange={handleChangeState}
      buttonProps={{
        theme: buttonTheme.text,
        "aria-label": "Goal state dropdown button",
      }}
    />
  );
};

export default GoalStateComponent;
